module.exports = __webpack_public_path__ + "img/button_locked_document.f4491719.svg";